var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleTop"},[_c('div',{staticClass:"titleTopLeft"},[_c('div',{staticClass:"tabBox",on:{"click":_vm.gonewClick}},[_c('i',{staticClass:"el-icon-s-shop"}),_vm._v(" 回到千越 ")])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleTopRight"},[_c('div',{staticClass:"titleTopRightPhone"},[_vm._v("手机版"),_c('i',{staticClass:"el-icon-mobile-phone"})])])
}]

export { render, staticRenderFns }